import type { IFutureFlag, FutureFlag } from '../types';

import { GEMX_FEATURE_FLAG } from '../constants';
import { isBrowser } from '~/utils';

export const checkFutureFlag = (
  key: FutureFlag,
  future?: IFutureFlag,
  shopMetaFlags?: Partial<IFutureFlag>,
): boolean => {
  if (shopMetaFlags?.[key]) return true;

  if (!future) return false;
  return future[key];
};
export const checkFutureFlagByStorage = (feature?: FutureFlag): boolean => {
  if (!isBrowser()) return false;

  const dataStorage = window.localStorage.getItem(GEMX_FEATURE_FLAG);
  const featureData = JSON.parse(dataStorage ?? '{}');
  if (!feature) return false;

  return featureData?.[feature] === 'true';
};
